import React from 'react';
import './styles/SignalLoader.css';

/** Equalizer bars + bouncing ball — network / wait indicator */
const SignalLoader = ({ className = '', size = 'md' }) => (
  <div
    className={`signal-loader signal-loader--${size} ${className}`.trim()}
    aria-hidden="true"
  >
    <div className="signal-loader__bar" />
    <div className="signal-loader__bar" />
    <div className="signal-loader__bar" />
    <div className="signal-loader__bar" />
    <div className="signal-loader__bar" />
    <div className="signal-loader__ball" />
  </div>
);

export default SignalLoader;
